"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var arrayExtensions_1 = require("spry-react/utils/arrayExtensions");
function toSelectFieldOptions(options, includeEmptyOption) {
    if (includeEmptyOption === void 0) { includeEmptyOption = true; }
    return buildSelectFieldOptions(options, includeEmptyOption).options;
}
exports.toSelectFieldOptions = toSelectFieldOptions;
function toSelectFieldProps(possiblyGroupedNamedOptions, currentValue, includeEmptyOption) {
    return buildSelectFieldOptions(possiblyGroupedNamedOptions, includeEmptyOption, currentValue);
}
exports.toSelectFieldProps = toSelectFieldProps;
function fromSelectFieldOption(namedOptions, selected) {
    return arrayExtensions_1.find(namedOptions, function (o) { return toSelectFieldValue(o) === selected.value; });
}
exports.fromSelectFieldOption = fromSelectFieldOption;
function buildSelectFieldOptions(possiblyGroupedCodes, includeEmptyOption, currentValue) {
    if (includeEmptyOption === void 0) { includeEmptyOption = true; }
    var options = [];
    var value = null;
    if (includeEmptyOption) {
        options.push({ value: '', text: '' });
    }
    var currentSelectFieldValue = null;
    if (currentValue)
        currentSelectFieldValue = toSelectFieldValue(currentValue);
    for (var _i = 0, possiblyGroupedCodes_1 = possiblyGroupedCodes; _i < possiblyGroupedCodes_1.length; _i++) {
        var codeOrGroup = possiblyGroupedCodes_1[_i];
        var option = void 0;
        if (isGroup(codeOrGroup)) {
            var groupOptions = [];
            for (var _a = 0, _b = codeOrGroup.options; _a < _b.length; _a++) {
                var groupCode = _b[_a];
                var groupOption = toSelectFieldOption(groupCode);
                groupOptions.push(groupOption);
                if (groupOption.value === currentSelectFieldValue)
                    value = groupOption;
            }
            option = { label: codeOrGroup.groupName, options: groupOptions };
        }
        else {
            option = toSelectFieldOption(codeOrGroup);
            if (option.value === currentSelectFieldValue)
                value = option;
        }
        options.push(option);
    }
    return {
        options: options,
        value: value
    };
}
function toSelectFieldOption(option) {
    return isSimpleCode(option)
        ? { value: option.id !== null ? option.id.toString() : '', text: option.name }
        : isKeyedCode(option)
            ? { value: option.systemKey, text: option.name }
            : isNamedCode(option)
                ? { value: option.name, text: option.name }
                : { value: option, text: option };
}
exports.toSelectFieldOption = toSelectFieldOption;
// this exactly matches the logic in toSelectFieldOption for getting the value ONLY of a NamedOption
function toSelectFieldValue(option) {
    return isSimpleCode(option)
        ? option.id !== null ? option.id.toString() : ''
        : isKeyedCode(option)
            ? option.systemKey
            : isNamedCode(option)
                ? option.name
                : option;
}
function isGroup(optionOrGroup) {
    return optionOrGroup.options !== undefined;
}
function isSimpleCode(namedThing) {
    return namedThing.id !== undefined;
}
function isKeyedCode(namedThing) {
    return namedThing.systemKey !== undefined;
}
function isNamedCode(namedThing) {
    return namedThing.name !== undefined;
}
